function updateBaseWidth () {
    const baseWidth = window.innerWidth
    if(baseWidth > 750 && baseWidth <= 1024){
      document.documentElement.style.setProperty('--base-width', 1024);
    }else if(baseWidth<=750){
      document.documentElement.style.setProperty('--base-width', 402);
      document.documentElement.style.setProperty('--base-font', 402);
    }

 
    const customEvent = new CustomEvent('baseWidthChange', { detail: baseWidth });
    document.dispatchEvent(customEvent);
  }
  updateBaseWidth()
  window.addEventListener('resize', updateBaseWidth)
  